import { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useGenerateWitness } from "../../hooks/useGenerateWitness";
import { toastAlert } from "../../utils/AlertContext";

export const GenerateWitnessModal = ({ open, onClose, note }) => {
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const { generateWitness, loading } = useGenerateWitness();

  const handleSelect = async (value) => {
    setSelected(value);
    try {
      const result = await generateWitness(note.cvcapsula, value);
      console.log(result);
      setStatus("success");
      if(result.message === "Error generando PDF con el nuevo metodo... Reportar"){
        toastAlert("Respuesta: " + result.message, "error");
      }else {
        toastAlert("Respuesta: " + result.message, "success");
      }
    } catch (error) {
      setStatus("error");
      toastAlert("Error al generar el testigo", "error");
    } finally {
      setTimeout(() => {
        setStatus(null);
        onClose();
      }, 3000);
    }
  };

  const getButtonProps = (isOldForm) => {
    const isThisSelected = selected === isOldForm;
    const isSuccess = status === "success" && isThisSelected;
    const isError = status === "error" && isThisSelected;

    return {
      variant: "contained",
      color: isSuccess ? "success" : isError ? "error" : "primary",
      disabled: (!isThisSelected && status === null) || loading,
      startIcon: loading && isThisSelected ? (
        <CircularProgress size={20} color="inherit" />
      ) : isSuccess ? (
        <CheckIcon />
      ) : isError ? (
        <CloseIcon />
      ) : null,
      children:
        loading && isThisSelected
          ? "Generando..."
          : isSuccess
          ? "Completado"
          : isError
          ? "Error"
          : "Generar",
      onClick: () => handleSelect(isOldForm),
    };
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          bgcolor: "background.paper",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          p: 3,
          width: "70%",
          maxWidth: 800,
          overflowY: "auto",
          outline: "none",
          borderRadius: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sx={{
              backgroundColor: selected === true ? "#b0bec591" : "#f0f0f0",
              p: 2,
              borderRadius: 2,
              opacity: selected === false ? 0.5 : 1,
              transition: "0.3s",
            }}
            onClick={() => setSelected(true)}
          >
            <Typography variant="h6" gutterBottom>
              Forma antigua (SEJDA)
            </Typography>
            <Typography variant="body2">
              En este apartado o punto se genera el testigo por la antigua forma, también llamado SEJDA.
            </Typography>
            <Box textAlign="center" mt={2}>
              <Button {...getButtonProps(true)} />
            </Box>
          </Grid>

          <Grid
            item
            xs={6}
            sx={{
              backgroundColor: selected === false ? "#b0bec591" : "#f0f0f0",
              p: 2,
              borderRadius: 2,
              opacity: selected === true ? 0.5 : 1,
              transition: "0.3s",
            }}
            onClick={() => setSelected(false)}
          >
            <Typography variant="h6" gutterBottom>
              Nueva forma
            </Typography>
            <Typography variant="body2">
              En esta opción se genera el testigo de la nueva forma.
            </Typography>
            <Box textAlign="center" mt={2}>
              <Button {...getButtonProps(false)} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
